import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'td-wb-expand-icon',
  templateUrl: 'expand-icon.component.html',
  styleUrls: ['expand-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.expanded]': 'expanded()',
    '[class.collapsed]': '!expanded()'
  }
})
export class ExpandIconComponent {
  readonly expanded: InputSignal<boolean> = input<boolean>(false);
}
